// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteApiShipmentsByIdDelayData, DeleteApiShipmentsByIdDelayErrors, DeleteApiShipmentsByIdDelayResponses, GetApiCustomerOrdersByIdData, GetApiCustomerOrdersByIdErrors, GetApiCustomerOrdersByIdResponses, GetApiCustomerOrdersData, GetApiCustomerOrdersErrors, GetApiCustomerOrdersResponses, GetApiPartnersByIdContractsData, GetApiPartnersByIdContractsErrors, GetApiPartnersByIdContractsResponses, GetApiPartnersByIdCounterpartiesData, GetApiPartnersByIdCounterpartiesErrors, GetApiPartnersByIdCounterpartiesResponses, GetApiPartnersByIdData, GetApiPartnersByIdDeliveryAddressData, GetApiPartnersByIdDeliveryAddressErrors, GetApiPartnersByIdDeliveryAddressResponses, GetApiPartnersByIdErrors, GetApiPartnersByIdLastContractData, GetApiPartnersByIdLastContractErrors, GetApiPartnersByIdLastContractResponses, GetApiPartnersByIdLastPricesData, GetApiPartnersByIdLastPricesErrors, GetApiPartnersByIdLastPricesResponses, GetApiPartnersByIdLastWarehouseData, GetApiPartnersByIdLastWarehouseErrors, GetApiPartnersByIdLastWarehouseResponses, GetApiPartnersByIdResponses, GetApiPartnersData, GetApiPartnersErrors, GetApiPartnersResponses, GetApiProductsData, GetApiProductsErrors, GetApiProductsGroupsData, GetApiProductsGroupsErrors, GetApiProductsGroupsResponses, GetApiProductsResponses, GetApiSampleTestsData, GetApiSampleTestsErrors, GetApiSampleTestsResponses, GetApiSettingsPlanningData, GetApiSettingsPlanningErrors, GetApiSettingsPlanningResponses, GetApiShipmentsByIdData, GetApiShipmentsByIdErrors, GetApiShipmentsByIdInvoiceData, GetApiShipmentsByIdInvoiceErrors, GetApiShipmentsByIdInvoiceResponses, GetApiShipmentsByIdResponses, GetApiShipmentsByIdVolumeAnalysisData, GetApiShipmentsByIdVolumeAnalysisErrors, GetApiShipmentsByIdVolumeAnalysisResponses, GetApiShipmentsData, GetApiShipmentsErrors, GetApiShipmentsResponses, GetApiShipmentsTaskSummaryData, GetApiShipmentsTaskSummaryErrors, GetApiShipmentsTaskSummaryResponses, GetApiSystemVersionData, GetApiSystemVersionErrors, GetApiSystemVersionResponses, GetApiWarehousesByIdAvailableStockData, GetApiWarehousesByIdAvailableStockErrors, GetApiWarehousesByIdAvailableStockResponses, GetApiWarehousesData, GetApiWarehousesErrors, GetApiWarehousesResponses, PostApiSampleTestsByIdFailData, PostApiSampleTestsByIdFailErrors, PostApiSampleTestsByIdFailResponses, PostApiSampleTestsByIdReopenData, PostApiSampleTestsByIdReopenErrors, PostApiSampleTestsByIdReopenResponses, PostApiSampleTestsByIdSucceedData, PostApiSampleTestsByIdSucceedErrors, PostApiSampleTestsByIdSucceedResponses, PostApiShipmentsByIdCancelData, PostApiShipmentsByIdCancelErrors, PostApiShipmentsByIdCancelResponses, PostApiShipmentsByIdDelayData, PostApiShipmentsByIdDelayErrors, PostApiShipmentsByIdDelayResponses, PostApiShipmentsByIdHandoverData, PostApiShipmentsByIdHandoverErrors, PostApiShipmentsByIdHandoverRequestOutcomeData, PostApiShipmentsByIdHandoverRequestOutcomeErrors, PostApiShipmentsByIdHandoverRequestOutcomeResponses, PostApiShipmentsByIdHandoverResponses, PostApiShipmentsByIdReturnToPlanData, PostApiShipmentsByIdReturnToPlanErrors, PostApiShipmentsByIdReturnToPlanResponses, PostApiShipmentsByIdReturnToPreparationData, PostApiShipmentsByIdReturnToPreparationErrors, PostApiShipmentsByIdReturnToPreparationResponses, PostApiShipmentsByIdSendToDeliveryData, PostApiShipmentsByIdSendToDeliveryErrors, PostApiShipmentsByIdSendToDeliveryResponses, PostApiShipmentsByIdTakeIntoWorkData, PostApiShipmentsByIdTakeIntoWorkErrors, PostApiShipmentsByIdTakeIntoWorkResponses, PostApiShipmentsData, PostApiShipmentsErrors, PostApiShipmentsForecastData, PostApiShipmentsForecastErrors, PostApiShipmentsForecastResponses, PostApiShipmentsFromForecastData, PostApiShipmentsFromForecastErrors, PostApiShipmentsFromForecastResponses, PostApiShipmentsResponses, PutApiPartnersByIdPaymentTermsData, PutApiPartnersByIdPaymentTermsErrors, PutApiPartnersByIdPaymentTermsResponses, PutApiPartnersByIdPlanningData, PutApiPartnersByIdPlanningErrors, PutApiPartnersByIdPlanningResponses, PutApiSampleTestsByIdScheduleData, PutApiSampleTestsByIdScheduleErrors, PutApiSampleTestsByIdScheduleResponses, PutApiSettingsPlanningData, PutApiSettingsPlanningErrors, PutApiSettingsPlanningResponses, PutApiShipmentsByIdApprovalStepsData, PutApiShipmentsByIdApprovalStepsErrors, PutApiShipmentsByIdApprovalStepsResponses, PutApiShipmentsByIdData, PutApiShipmentsByIdDeliveryData, PutApiShipmentsByIdDeliveryErrors, PutApiShipmentsByIdDeliveryResponses, PutApiShipmentsByIdDocumentsData, PutApiShipmentsByIdDocumentsErrors, PutApiShipmentsByIdDocumentsResponses, PutApiShipmentsByIdErrors, PutApiShipmentsByIdNextShipmentIntervalsData, PutApiShipmentsByIdNextShipmentIntervalsErrors, PutApiShipmentsByIdNextShipmentIntervalsResponses, PutApiShipmentsByIdResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Возвращает страницу заказов клиентов; по умолчанию - действующих, новые сверху.
 */
export const getApiCustomerOrders = <ThrowOnError extends boolean = false>(options?: Options<GetApiCustomerOrdersData, ThrowOnError>) => (options?.client ?? client).get<GetApiCustomerOrdersResponses, GetApiCustomerOrdersErrors, ThrowOnError>({ url: '/api/CustomerOrders', ...options });

/**
 * Возвращает карточку заказа клиента со строками.
 */
export const getApiCustomerOrdersById = <ThrowOnError extends boolean = false>(options: Options<GetApiCustomerOrdersByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiCustomerOrdersByIdResponses, GetApiCustomerOrdersByIdErrors, ThrowOnError>({ url: '/api/CustomerOrders/{id}', ...options });

/**
 * Возвращает страницу партнёров; по умолчанию - действующих клиентов.
 */
export const getApiPartners = <ThrowOnError extends boolean = false>(options?: Options<GetApiPartnersData, ThrowOnError>) => (options?.client ?? client).get<GetApiPartnersResponses, GetApiPartnersErrors, ThrowOnError>({ url: '/api/Partners', ...options });

/**
 * Возвращает партнёра по идентификатору.
 */
export const getApiPartnersById = <ThrowOnError extends boolean = false>(options: Options<GetApiPartnersByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiPartnersByIdResponses, GetApiPartnersByIdErrors, ThrowOnError>({ url: '/api/Partners/{id}', ...options });

/**
 * Возвращает действующих контрагентов партнёра.
 */
export const getApiPartnersByIdCounterparties = <ThrowOnError extends boolean = false>(options: Options<GetApiPartnersByIdCounterpartiesData, ThrowOnError>) => (options.client ?? client).get<GetApiPartnersByIdCounterpartiesResponses, GetApiPartnersByIdCounterpartiesErrors, ThrowOnError>({ url: '/api/Partners/{id}/counterparties', ...options });

/**
 * Возвращает договоры клиента, годные для выбора в отгрузке.
 *
 * Договоры с клиентом, действующие в 1С, на действующего контрагента клиента; по наименованию.
 */
export const getApiPartnersByIdContracts = <ThrowOnError extends boolean = false>(options: Options<GetApiPartnersByIdContractsData, ThrowOnError>) => (options.client ?? client).get<GetApiPartnersByIdContractsResponses, GetApiPartnersByIdContractsErrors, ThrowOnError>({ url: '/api/Partners/{id}/contracts', ...options });

/**
 * Возвращает договор, который форма отгрузки подставляет клиенту, - подсказку для договора отгрузки.
 *
 * Договор прошлого заказа клиента с этого склада, без него - прошлого заказа клиента, без него - единственный
 * договор; только годный для заказа. Подсказки нет - поля ответа пустые.
 */
export const getApiPartnersByIdLastContract = <ThrowOnError extends boolean = false>(options: Options<GetApiPartnersByIdLastContractData, ThrowOnError>) => (options.client ?? client).get<GetApiPartnersByIdLastContractResponses, GetApiPartnersByIdLastContractErrors, ThrowOnError>({ url: '/api/Partners/{id}/last-contract', ...options });

/**
 * Возвращает прошлую цену клиента по продуктам - подсказку для строки отгрузки.
 *
 * Продукта, который клиент не брал, в ответе нет.
 */
export const getApiPartnersByIdLastPrices = <ThrowOnError extends boolean = false>(options: Options<GetApiPartnersByIdLastPricesData, ThrowOnError>) => (options.client ?? client).get<GetApiPartnersByIdLastPricesResponses, GetApiPartnersByIdLastPricesErrors, ThrowOnError>({ url: '/api/Partners/{id}/last-prices', ...options });

/**
 * Возвращает склад прошлого заказа клиента - подсказку для склада отгрузки.
 *
 * Подсказки нет - поля ответа пустые.
 */
export const getApiPartnersByIdLastWarehouse = <ThrowOnError extends boolean = false>(options: Options<GetApiPartnersByIdLastWarehouseData, ThrowOnError>) => (options.client ?? client).get<GetApiPartnersByIdLastWarehouseResponses, GetApiPartnersByIdLastWarehouseErrors, ThrowOnError>({ url: '/api/Partners/{id}/last-warehouse', ...options });

/**
 * Возвращает адрес доставки по умолчанию для новой отгрузки клиента.
 *
 * Адрес последнего заказа клиента, без него - адрес партнёра; подсказки нет - поля ответа пустые.
 */
export const getApiPartnersByIdDeliveryAddress = <ThrowOnError extends boolean = false>(options: Options<GetApiPartnersByIdDeliveryAddressData, ThrowOnError>) => (options.client ?? client).get<GetApiPartnersByIdDeliveryAddressResponses, GetApiPartnersByIdDeliveryAddressErrors, ThrowOnError>({ url: '/api/Partners/{id}/delivery-address', ...options });

/**
 * Исключает клиента из плана из истории или возвращает его туда.
 */
export const putApiPartnersByIdPlanning = <ThrowOnError extends boolean = false>(options: Options<PutApiPartnersByIdPlanningData, ThrowOnError>) => (options.client ?? client).put<PutApiPartnersByIdPlanningResponses, PutApiPartnersByIdPlanningErrors, ThrowOnError>({
    url: '/api/Partners/{id}/planning',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Задаёт условия оплаты клиента или снимает их.
 *
 * Наши поля: в 1С условия по клиентам системно не ведутся. Процент - у частичной предоплаты, дни - у отсрочки.
 */
export const putApiPartnersByIdPaymentTerms = <ThrowOnError extends boolean = false>(options: Options<PutApiPartnersByIdPaymentTermsData, ThrowOnError>) => (options.client ?? client).put<PutApiPartnersByIdPaymentTermsResponses, PutApiPartnersByIdPaymentTermsErrors, ThrowOnError>({
    url: '/api/Partners/{id}/payment-terms',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Возвращает страницу справочника продуктов.
 *
 * Успешный ответ объявлен атрибутом явно: возвращаемый тип обёрнут в
 * Result<TValue> и разворачивается фильтром
 * `TranslateResultToActionResult`, поэтому генератор OpenAPI сам вывести схему не
 * может - без атрибута в документе не будет ни ответа 200, ни схемы ProductDto,
 * и сгенерированный клиент получит нетипизированный ответ.
 */
export const getApiProducts = <ThrowOnError extends boolean = false>(options?: Options<GetApiProductsData, ThrowOnError>) => (options?.client ?? client).get<GetApiProductsResponses, GetApiProductsErrors, ThrowOnError>({ url: '/api/Products', ...options });

/**
 * Возвращает группы номенклатуры, в которых есть позиции, - для фильтра справочника.
 */
export const getApiProductsGroups = <ThrowOnError extends boolean = false>(options?: Options<GetApiProductsGroupsData, ThrowOnError>) => (options?.client ?? client).get<GetApiProductsGroupsResponses, GetApiProductsGroupsErrors, ThrowOnError>({ url: '/api/Products/groups', ...options });

/**
 * Возвращает страницу тестов; по умолчанию - все, ближайшие по дате теста сверху.
 *
 * «Узнать результат теста» на «Моих задачах» - `isDue=true`, счётчик - `totalRecords`.
 */
export const getApiSampleTests = <ThrowOnError extends boolean = false>(options?: Options<GetApiSampleTestsData, ThrowOnError>) => (options?.client ?? client).get<GetApiSampleTestsResponses, GetApiSampleTestsErrors, ThrowOnError>({ url: '/api/SampleTests', ...options });

/**
 * Переносит тест: дата теста и комментарий; статус не меняется.
 *
 * Только в «Тестируется», иначе 409 `sample_test_not_testing`. Перенесённая дата за днём отгрузки больше не следует.
 */
export const putApiSampleTestsByIdSchedule = <ThrowOnError extends boolean = false>(options: Options<PutApiSampleTestsByIdScheduleData, ThrowOnError>) => (options.client ?? client).put<PutApiSampleTestsByIdScheduleResponses, PutApiSampleTestsByIdScheduleErrors, ThrowOnError>({
    url: '/api/SampleTests/{id}/schedule',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Закрывает тест итогом «Одобрено».
 *
 * Только из «Тестируется», иначе 409 `sample_test_not_testing`. Пустой комментарий оставляет прежний.
 */
export const postApiSampleTestsByIdSucceed = <ThrowOnError extends boolean = false>(options: Options<PostApiSampleTestsByIdSucceedData, ThrowOnError>) => (options.client ?? client).post<PostApiSampleTestsByIdSucceedResponses, PostApiSampleTestsByIdSucceedErrors, ThrowOnError>({
    url: '/api/SampleTests/{id}/succeed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Закрывает тест итогом «Не подошло».
 *
 * Только из «Тестируется», иначе 409 `sample_test_not_testing`. Пустой комментарий оставляет прежний.
 */
export const postApiSampleTestsByIdFail = <ThrowOnError extends boolean = false>(options: Options<PostApiSampleTestsByIdFailData, ThrowOnError>) => (options.client ?? client).post<PostApiSampleTestsByIdFailResponses, PostApiSampleTestsByIdFailErrors, ThrowOnError>({
    url: '/api/SampleTests/{id}/fail',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * «Вернуть в тестирование»: закрытый тест - снова в «Тестируется».
 *
 * Итог и время закрытия снимаются, комментарий и дата теста остаются. Тест в «Тестируется» - 409 `sample_test_not_closed`.
 */
export const postApiSampleTestsByIdReopen = <ThrowOnError extends boolean = false>(options: Options<PostApiSampleTestsByIdReopenData, ThrowOnError>) => (options.client ?? client).post<PostApiSampleTestsByIdReopenResponses, PostApiSampleTestsByIdReopenErrors, ThrowOnError>({ url: '/api/SampleTests/{id}/reopen', ...options });

/**
 * Возвращает настройки плана из истории; пока их не меняли - значения по умолчанию.
 */
export const getApiSettingsPlanning = <ThrowOnError extends boolean = false>(options?: Options<GetApiSettingsPlanningData, ThrowOnError>) => (options?.client ?? client).get<GetApiSettingsPlanningResponses, GetApiSettingsPlanningErrors, ThrowOnError>({ url: '/api/Settings/planning', ...options });

/**
 * Меняет настройки плана из истории: горизонт и глубину истории.
 */
export const putApiSettingsPlanning = <ThrowOnError extends boolean = false>(options: Options<PutApiSettingsPlanningData, ThrowOnError>) => (options.client ?? client).put<PutApiSettingsPlanningResponses, PutApiSettingsPlanningErrors, ThrowOnError>({
    url: '/api/Settings/planning',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Возвращает страницу отгрузок; по умолчанию - все, ближайшие по плановой дате сверху.
 */
export const getApiShipments = <ThrowOnError extends boolean = false>(options?: Options<GetApiShipmentsData, ThrowOnError>) => (options?.client ?? client).get<GetApiShipmentsResponses, GetApiShipmentsErrors, ThrowOnError>({ url: '/api/Shipments', ...options });

/**
 * Создаёт отгрузку в статусе «Запланировано»; контрагента подставляет сервер.
 */
export const postApiShipments = <ThrowOnError extends boolean = false>(options: Options<PostApiShipmentsData, ThrowOnError>) => (options.client ?? client).post<PostApiShipmentsResponses, PostApiShipmentsErrors, ThrowOnError>({
    url: '/api/Shipments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Возвращает карточку отгрузки.
 */
export const getApiShipmentsById = <ThrowOnError extends boolean = false>(options: Options<GetApiShipmentsByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiShipmentsByIdResponses, GetApiShipmentsByIdErrors, ThrowOnError>({ url: '/api/Shipments/{id}', ...options });

/**
 * Правит отгрузку; строки заменяются целиком.
 */
export const putApiShipmentsById = <ThrowOnError extends boolean = false>(options: Options<PutApiShipmentsByIdData, ThrowOnError>) => (options.client ?? client).put<PutApiShipmentsByIdResponses, PutApiShipmentsByIdErrors, ThrowOnError>({
    url: '/api/Shipments/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Возвращает сводку «Моих задач»: показатели, задачи по статусам, клиенты с задачами.
 */
export const getApiShipmentsTaskSummary = <ThrowOnError extends boolean = false>(options?: Options<GetApiShipmentsTaskSummaryData, ThrowOnError>) => (options?.client ?? client).get<GetApiShipmentsTaskSummaryResponses, GetApiShipmentsTaskSummaryErrors, ThrowOnError>({ url: '/api/Shipments/task-summary', ...options });

/**
 * План из истории: предложенные отгрузки по клиентам с правками менеджера; ничего не пишет.
 *
 * POST, а не GET: правки менеджера приходят телом и пересчитываются целиком.
 */
export const postApiShipmentsForecast = <ThrowOnError extends boolean = false>(options: Options<PostApiShipmentsForecastData, ThrowOnError>) => (options.client ?? client).post<PostApiShipmentsForecastResponses, PostApiShipmentsForecastErrors, ThrowOnError>({
    url: '/api/Shipments/forecast',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Создаёт выбранные в плане из истории отгрузки одним сохранением - все или ни одной.
 */
export const postApiShipmentsFromForecast = <ThrowOnError extends boolean = false>(options: Options<PostApiShipmentsFromForecastData, ThrowOnError>) => (options.client ?? client).post<PostApiShipmentsFromForecastResponses, PostApiShipmentsFromForecastErrors, ThrowOnError>({
    url: '/api/Shipments/from-forecast',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Задаёт строкам интервал до следующей отгрузки продукта - в любом статусе, кроме «Отменено».
 *
 * Интервал - данные планирования, а не поле заказа 1С: пишется и в завершённую, и в связанную с заказом отгрузку.
 */
export const putApiShipmentsByIdNextShipmentIntervals = <ThrowOnError extends boolean = false>(options: Options<PutApiShipmentsByIdNextShipmentIntervalsData, ThrowOnError>) => (options.client ?? client).put<PutApiShipmentsByIdNextShipmentIntervalsResponses, PutApiShipmentsByIdNextShipmentIntervalsErrors, ThrowOnError>({
    url: '/api/Shipments/{id}/next-shipment-intervals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * «Взять в работу»: «Запланировано» -> «Согласование».
 *
 * Тем же сохранением строки с интервалом до следующей отгрузки получают следующие отгрузки
 * «Запланировано»; в карточке они видны у строк (`nextShipment`).
 */
export const postApiShipmentsByIdTakeIntoWork = <ThrowOnError extends boolean = false>(options: Options<PostApiShipmentsByIdTakeIntoWorkData, ThrowOnError>) => (options.client ?? client).post<PostApiShipmentsByIdTakeIntoWorkResponses, PostApiShipmentsByIdTakeIntoWorkErrors, ThrowOnError>({ url: '/api/Shipments/{id}/take-into-work', ...options });

/**
 * «Назад по этапу»: «Согласование» -> «Запланировано», пока заказа в 1С нет.
 *
 * После передачи в 1С - 409 `shipment_not_in_approval`: статус ведёт заказ 1С. Отметки
 * согласования снимаются; повторное «Взять в работу» следующих отгрузок второй раз не создаёт.
 */
export const postApiShipmentsByIdReturnToPlan = <ThrowOnError extends boolean = false>(options: Options<PostApiShipmentsByIdReturnToPlanData, ThrowOnError>) => (options.client ?? client).post<PostApiShipmentsByIdReturnToPlanResponses, PostApiShipmentsByIdReturnToPlanErrors, ThrowOnError>({ url: '/api/Shipments/{id}/return-to-plan', ...options });

/**
 * «Передать в доставку»: «Подготовка» -> «Доставка» (ADR-013).
 *
 * Открыто, когда заказ в 1С проведён и не ждёт согласования, предоплаты или обеспечения; иначе 409
 * `shipment_delivery_not_allowed`. Трек-номер и дата отгрузки - необязательны.
 */
export const postApiShipmentsByIdSendToDelivery = <ThrowOnError extends boolean = false>(options: Options<PostApiShipmentsByIdSendToDeliveryData, ThrowOnError>) => (options.client ?? client).post<PostApiShipmentsByIdSendToDeliveryResponses, PostApiShipmentsByIdSendToDeliveryErrors, ThrowOnError>({
    url: '/api/Shipments/{id}/send-to-delivery',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Задаёт данные доставки - трек-номер и дату отгрузки.
 *
 * На любом этапе, кроме «Отменено» (409 `shipment_cancelled`); в 1С не уходят.
 */
export const putApiShipmentsByIdDelivery = <ThrowOnError extends boolean = false>(options: Options<PutApiShipmentsByIdDeliveryData, ThrowOnError>) => (options.client ?? client).put<PutApiShipmentsByIdDeliveryResponses, PutApiShipmentsByIdDeliveryErrors, ThrowOnError>({
    url: '/api/Shipments/{id}/delivery',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * «Назад по этапу»: «Доставка» -> «Подготовка», пока 1С не отгрузила заказ.
 *
 * Не в «Доставке» - 409 `shipment_not_in_delivery`; заказ уже отгружен - 409
 * `shipment_order_already_shipped`.
 */
export const postApiShipmentsByIdReturnToPreparation = <ThrowOnError extends boolean = false>(options: Options<PostApiShipmentsByIdReturnToPreparationData, ThrowOnError>) => (options.client ?? client).post<PostApiShipmentsByIdReturnToPreparationResponses, PostApiShipmentsByIdReturnToPreparationErrors, ThrowOnError>({ url: '/api/Shipments/{id}/return-to-preparation', ...options });

/**
 * Отменяет отгрузку с причиной, пока в 1С нет заказа.
 */
export const postApiShipmentsByIdCancel = <ThrowOnError extends boolean = false>(options: Options<PostApiShipmentsByIdCancelData, ThrowOnError>) => (options.client ?? client).post<PostApiShipmentsByIdCancelResponses, PostApiShipmentsByIdCancelErrors, ThrowOnError>({
    url: '/api/Shipments/{id}/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Снимает метку задержки.
 */
export const deleteApiShipmentsByIdDelay = <ThrowOnError extends boolean = false>(options: Options<DeleteApiShipmentsByIdDelayData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiShipmentsByIdDelayResponses, DeleteApiShipmentsByIdDelayErrors, ThrowOnError>({ url: '/api/Shipments/{id}/delay', ...options });

/**
 * Помечает отгрузку задержанной с причиной; у задержанной меняет причину.
 *
 * Метка поверх статуса - на любом этапе, кроме закрытых (409 `shipment_closed`).
 */
export const postApiShipmentsByIdDelay = <ThrowOnError extends boolean = false>(options: Options<PostApiShipmentsByIdDelayData, ThrowOnError>) => (options.client ?? client).post<PostApiShipmentsByIdDelayResponses, PostApiShipmentsByIdDelayErrors, ThrowOnError>({
    url: '/api/Shipments/{id}/delay',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Отмечает шаг согласования выполненным или снимает отметку.
 *
 * Только на «Согласовании» до передачи в 1С; шаги - по порядку, снятие снимает и следующие. Пока все
 * три не отмечены, передача в 1С закрыта.
 */
export const putApiShipmentsByIdApprovalSteps = <ThrowOnError extends boolean = false>(options: Options<PutApiShipmentsByIdApprovalStepsData, ThrowOnError>) => (options.client ?? client).put<PutApiShipmentsByIdApprovalStepsResponses, PutApiShipmentsByIdApprovalStepsErrors, ThrowOnError>({
    url: '/api/Shipments/{id}/approval-steps',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Отмечает документ отгрузки подготовленным или снимает отметку.
 *
 * Чек-лист менеджера, переходы не блокирует; у закрытой отгрузки - 409 `shipment_closed`.
 * Документ на товар - с продуктом из строк отгрузки, на отгрузку целиком - без продукта.
 */
export const putApiShipmentsByIdDocuments = <ThrowOnError extends boolean = false>(options: Options<PutApiShipmentsByIdDocumentsData, ThrowOnError>) => (options.client ?? client).put<PutApiShipmentsByIdDocumentsResponses, PutApiShipmentsByIdDocumentsErrors, ThrowOnError>({
    url: '/api/Shipments/{id}/documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Анализ объёма: количество продуктов отгрузки против прошлых поставок клиента.
 */
export const getApiShipmentsByIdVolumeAnalysis = <ThrowOnError extends boolean = false>(options: Options<GetApiShipmentsByIdVolumeAnalysisData, ThrowOnError>) => (options.client ?? client).get<GetApiShipmentsByIdVolumeAnalysisResponses, GetApiShipmentsByIdVolumeAnalysisErrors, ThrowOnError>({ url: '/api/Shipments/{id}/volume-analysis', ...options });

/**
 * Счёт на оплату заказа 1С, созданного по отгрузке, - PDF для скачивания.
 *
 * Не JSON, поэтому действие возвращает файл и объявляет свой 200 (design-guidelines/http-api.md,
 * «Контроллер»). Нет заказа или счёт ещё формируется - 404 `shipment_invoice_not_found`; есть ли счёт,
 * видно в карточке (`invoice`).
 */
export const getApiShipmentsByIdInvoice = <ThrowOnError extends boolean = false>(options: Options<GetApiShipmentsByIdInvoiceData, ThrowOnError>) => (options.client ?? client).get<GetApiShipmentsByIdInvoiceResponses, GetApiShipmentsByIdInvoiceErrors, ThrowOnError>({ url: '/api/Shipments/{id}/invoice', ...options });

/**
 * «Сформировать заказ в 1С»: отгрузка «в пути», команда уходит процессом; повтор после отказа - тоже сюда.
 *
 * Исход приходит позже событием из 1С: карточку опрашивают, пока передача «в пути».
 */
export const postApiShipmentsByIdHandover = <ThrowOnError extends boolean = false>(options: Options<PostApiShipmentsByIdHandoverData, ThrowOnError>) => (options.client ?? client).post<PostApiShipmentsByIdHandoverResponses, PostApiShipmentsByIdHandoverErrors, ThrowOnError>({ url: '/api/Shipments/{id}/handover', ...options });

/**
 * «Запросить исход» из «нет ответа от 1С»: та же команда уходит ещё раз.
 */
export const postApiShipmentsByIdHandoverRequestOutcome = <ThrowOnError extends boolean = false>(options: Options<PostApiShipmentsByIdHandoverRequestOutcomeData, ThrowOnError>) => (options.client ?? client).post<PostApiShipmentsByIdHandoverRequestOutcomeResponses, PostApiShipmentsByIdHandoverRequestOutcomeErrors, ThrowOnError>({ url: '/api/Shipments/{id}/handover/request-outcome', ...options });

/**
 * Возвращает метку сборки работающего хоста.
 *
 * Нужен, чтобы отличить «стенд не обновился» от «изменение не работает» без захода на сервер.
 */
export const getApiSystemVersion = <ThrowOnError extends boolean = false>(options?: Options<GetApiSystemVersionData, ThrowOnError>) => (options?.client ?? client).get<GetApiSystemVersionResponses, GetApiSystemVersionErrors, ThrowOnError>({ url: '/api/System/version', ...options });

/**
 * Возвращает склады по наименованию; по умолчанию - действующие.
 */
export const getApiWarehouses = <ThrowOnError extends boolean = false>(options?: Options<GetApiWarehousesData, ThrowOnError>) => (options?.client ?? client).get<GetApiWarehousesResponses, GetApiWarehousesErrors, ThrowOnError>({ url: '/api/Warehouses', ...options });

/**
 * Возвращает свободный остаток продуктов на складе - по копии остатков 1С, для строк формы отгрузки.
 *
 * Каждый запрошенный продукт - в ответе; остаток неизвестен - `availableQuantity: null`.
 */
export const getApiWarehousesByIdAvailableStock = <ThrowOnError extends boolean = false>(options: Options<GetApiWarehousesByIdAvailableStockData, ThrowOnError>) => (options.client ?? client).get<GetApiWarehousesByIdAvailableStockResponses, GetApiWarehousesByIdAvailableStockErrors, ThrowOnError>({ url: '/api/Warehouses/{id}/available-stock', ...options });
